module.exports = __webpack_public_path__ + "img/lunpan_start.60ab781f.png";